import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

const art = [
  {
    _id: uuid(),
    title: "Techno ape",
    creator: "Bored ape club",
    price: "1220",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#1139",
    img: "https://user-images.githubusercontent.com/52632590/158341242-025ecece-bdbd-488a-9b74-299872008b9f.jpg",
    ratings: 2,
    ratingsCount: 76,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "The Last Doll",
    creator: "Stephen Tompkins",
    price: "1520",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#1239",
    img: "https://user-images.githubusercontent.com/52632590/158342850-2ebe9a70-977e-457b-a751-49d6ef6fa513.jpg",
    ratings: 1,
    ratingsCount: 126,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Crypto Van Gogh",
    creator: "Crypto punk",
    price: "2505",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#239",
    img: "https://user-images.githubusercontent.com/52632590/158343162-3b68b1dc-b4ee-4955-b6f7-f760529a0002.jpg",
    ratings: 4,
    ratingsCount: 216,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "The Mutant Ape",
    creator: "The Mutant Ape Yacht",
    price: "1780",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#2139",
    img: "https://user-images.githubusercontent.com/52632590/158343320-5034d145-bdeb-4b54-8bb1-2d348c70d9b7.jpg",
    ratings: 3,
    ratingsCount: 126,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Cute Monsters",
    creator: "Halloween monters",
    price: "2100",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#339",
    img: "https://user-images.githubusercontent.com/52632590/158343472-3dc9b28d-b3ad-4f95-9507-f78c12fc472f.jpg",
    ratings: 3,
    ratingsCount: 112,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "The Bored Ape",
    creator: "Bored ape NFT",
    price: "2001",
    categoryName: "Art",
    topBid: "1500",
    minBid: "900",
    rank: "#1139",
    img: "https://user-images.githubusercontent.com/52632590/158343639-e9f63b7e-ad78-436e-9731-1e73346ca033.jpg",
    ratings: 2,
    ratingsCount: 86,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "NIKE x DXTR",
    creator: "Spring Summer",
    price: "1000",
    categoryName: "Art",
    topBid: "3200",
    minBid: "900",
    rank: "#1042",
    img: "https://user-images.githubusercontent.com/52632590/158343759-d3d5a0f8-fc39-411e-aa35-309ddb4d2b15.jpg",
    ratings: 4,
    ratingsCount: 325,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Juxtapoz Magazine",
    creator: "DTRX The Weird",
    price: "1000",
    categoryName: "Art",
    topBid: "4500",
    minBid: "900",
    rank: "#315",
    img: "https://user-images.githubusercontent.com/52632590/158343871-3b4e449d-097e-49d6-9ed0-3e09b74e7e1e.jpg",
    ratings: 5,
    ratingsCount: 108,
    status: "Trending",
  },
];

const collectibles = [
  {
    _id: uuid(),
    title: "Meeting Table (Boop Goop)",
    creator: "AndyRichy",
    price: "1983",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/49674193-ded1-42dc-b6ba-2e7f09137a96/preview?bafkreiedt2dweyhxxpkhqaqhl3x5h3b2y2yh7vfa3b5ri2y3ixg43dkauu",
    ratings: 3,
    ratingsCount: 107,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Lantern Tiger",
    creator: "HorizonLin",
    price: "226",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/60213390-6609-40f7-b42d-ba5943af1b3d/preview?bafkreic5n2ozcslxodyownqioc7c2ntq2cdnojztxyjhjssowhmi723vua?bafkreic5n2ozcslxodyownqioc7c2ntq2cdnojztxyjhjssowhmi723vua",
    ratings: 3,
    ratingsCount: 107,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Chinese New Year Lion",
    creator: "IDSAND",
    price: "356",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/86ad7763-385c-4090-906b-6dbe7fee1c97/preview?bafkreihzs2cdtajqootng6roa7wflqyffl4aczmubalupsscx7kd2tmaxy?bafkreihzs2cdtajqootng6roa7wflqyffl4aczmubalupsscx7kd2tmaxy",
    ratings: 3,
    ratingsCount: 107,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Boop Goop Fountain",
    creator: "AndyRichy",
    price: "787",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/fa1db0a9-168d-4c22-8764-714d652575a1/preview?bafkreide6ouin3odnbah55j5bsshhzb67ex3b6to25oxbexwwkxeidwxj4?bafkreide6ouin3odnbah55j5bsshhzb67ex3b6to25oxbexwwkxeidwxj4",
    ratings: 3,
    ratingsCount: 107,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Kinetic Energy Statue",
    creator: "Hotshot",
    price: "3748",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/61a269c0-0b17-4fdd-ac95-b3fc777fe153/preview?bafkreidb6rkfmwo7p5gjqwjvec5od5qwzpxuytrljrctsyvn3v56cfmuq4?bafkreidb6rkfmwo7p5gjqwjvec5od5qwzpxuytrljrctsyvn3v56cfmuq4",
    ratings: 3,
    ratingsCount: 107,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "P Eagle monument",
    creator: "Momo",
    price: "1869",
    categoryName: "Collectibles",
    topBid: "7095",
    minBid: "2006",
    rank: "#139",
    img: "https://api.sandbox.game/assets/public/66732349-d4f3-45e3-8519-e30575f3d124/preview?bafkreifdmvcua7jbpwaf375rzv4bmazv55dsfv27bvxxg2jfohezvyfrpi?bafkreifdmvcua7jbpwaf375rzv4bmazv55dsfv27bvxxg2jfohezvyfrpi",
    ratings: 3,
    ratingsCount: 107,
    status: "Trending",
  },
];

const wearable = [
  {
    _id: uuid(),
    title: "Wizzy the Blue - Head",
    creator: "KamiSawZe",
    price: "3207",
    categoryName: "Wearable",
    topBid: "9022",
    minBid: "4501",
    rank: "#201",
    img: "https://api.sandbox.game/assets/public/7013dc8e-6d1d-409e-8cec-51dba5b408c1/preview?bafkreibnvolh7myxo7wuozel4atkzichy3kjwtnaziixh6k6rov23a5ynm?bafkreibnvolh7myxo7wuozel4atkzichy3kjwtnaziixh6k6rov23a5ynm",
    ratings: 2,
    ratingsCount: 104,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Cyberduck Head",
    creator: "Sandboi",
    price: "2310",
    categoryName: "Wearable",
    topBid: "4583",
    minBid: "3021",
    rank: "#231",
    img: "https://api.sandbox.game/assets/public/0b7c962d-ea3b-484e-b1bf-9c6a6122f243/preview?bafkreiat43kyiqxogeqeq7neb6qyglpae3jmni4zfizsrmbh3mugb5buru?bafkreiat43kyiqxogeqeq7neb6qyglpae3jmni4zfizsrmbh3mugb5buru",
    ratings: 3,
    ratingsCount: 331,
    status: "Trending",
  },

  {
    _id: uuid(),
    title: "Santa Wizzy Head 2",
    creator: "KamiSawZe",
    price: "2301",
    categoryName: "Wearable",
    topBid: "7804",
    minBid: "3401",
    rank: "#341",
    img: "https://api.sandbox.game/assets/public/e5d4c8f5-d53f-4d83-9d08-239d37622ae9/preview?bafkreiezvszwzdyr5kvxt3gwyykp32yd7nvvxn2dl55wuya5zjxnhoi45m?bafkreiezvszwzdyr5kvxt3gwyykp32yd7nvvxn2dl55wuya5zjxnhoi45m",
    ratings: 5,
    ratingsCount: 231,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Kraradazt Head",
    creator: "kraradazt",
    price: "341",
    categoryName: "Wearable",
    topBid: "321",
    minBid: "200",
    rank: "#117",
    img: "https://api.sandbox.game/assets/public/2e19ffd4-a7ac-4258-b185-4c5173fb1177/preview?bafkreiho6xhipgezsnwf7grqglnlpvqvdsnjlholsih67zgscdd6337swy?bafkreiho6xhipgezsnwf7grqglnlpvqvdsnjlholsih67zgscdd6337swy",
    ratings: 1,
    ratingsCount: 4,
    status: "Trending",
  },
];

const equipment = [
  {
    _id: uuid(),
    title: "AURA - Pheonix",
    creator: "TranceNFT",
    price: "3717",
    categoryName: "Equipment",
    topBid: "9022",
    minBid: "4501",
    rank: "#116",
    img: "https://api.sandbox.game/assets/public/6a2761a3-dccc-42c9-b4a2-4230143a3cfd/preview?bafkreib5shz36cfvpwbj53yxl2tvmbmkk6to3igenl3zmkmuvbqm2osclm?bafkreib5shz36cfvpwbj53yxl2tvmbmkk6to3igenl3zmkmuvbqm2osclm",
    ratings: 4,
    ratingsCount: 34,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Golden Inferno Blade",
    creator: "SandstormMeet",
    price: "107",
    categoryName: "Equipment",
    topBid: "340",
    minBid: "150",
    rank: "#115",
    img: "https://api.sandbox.game/assets/public/7358ce38-d8f1-4c4d-bacf-37c47daa8485/preview?bafkreigxxfou2hiu3ajsm3w3uwiiunidnzkhq5dhyemznpcghmxabo23d4?bafkreigxxfou2hiu3ajsm3w3uwiiunidnzkhq5dhyemznpcghmxabo23d4",
    ratings: 4,
    ratingsCount: 102,
    status: "Trending",
  },

  {
    _id: uuid(),
    title: "Vortex Storm Shield",
    creator: "SandstormMeet",
    price: "104",
    categoryName: "Equipment",
    topBid: "500",
    minBid: "200",
    rank: "#118",
    img: "https://api.sandbox.game/assets/public/88793c89-e3ae-4339-813e-0e41f519e05d/preview?bafkreigkjcxqdk7whqkl3z6eikiozixsbm4kwpzvxwkkraodhb6sv7kx2y?bafkreigkjcxqdk7whqkl3z6eikiozixsbm4kwpzvxwkkraodhb6sv7kx2y",
    ratings: 2,
    ratingsCount: 102,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Tempel Tuttle Chelsea Boot - Black",
    creator: "deadstock",
    price: "104",
    categoryName: "Equipment",
    topBid: "321",
    minBid: "200",
    rank: "#117",
    img: "https://api.sandbox.game/assets/public/6ad2078c-c7eb-44d2-a532-ae6a3b9f16c3/preview?bafkreievlqvjoajfjx7yz7rlaoerbtefbctmec4fqkdc73op526qpk4voi?bafkreievlqvjoajfjx7yz7rlaoerbtefbctmec4fqkdc73op526qpk4voi",
    ratings: 1,
    ratingsCount: 4,
    status: "Popular",
  },
];

const entities = [
  {
    _id: uuid(),
    title: "Jellyfish Deep Ocean Lamp",
    creator: "AnneAn",
    price: "149",
    categoryName: "Entities",
    topBid: "2022",
    minBid: "1023",
    rank: "#111",
    img: "https://api.sandbox.game/assets/public/888599ec-1ae7-4b1e-a6e0-fc7284b9cf6b/preview?bafkreiefexgbk3yjsm5fxhavtm6w77lpwzizhnh2u64xm42rkrk3d76cw4?bafkreiefexgbk3yjsm5fxhavtm6w77lpwzizhnh2u64xm42rkrk3d76cw4",
    ratings: 3,
    ratingsCount: 107,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Sentient Flower Pot",
    creator: "Loccle",
    price: "74",
    categoryName: "Entities",
    topBid: "250",
    minBid: "100",
    rank: "#112",
    img: "https://api.sandbox.game/assets/public/6a9795a4-9738-4055-94ad-5f5793184edb/preview?bafkreieuj3ut3icjyi3vhs7ie7iloost5m7ohoufrmd45h2ruesfipsbnm?bafkreieuj3ut3icjyi3vhs7ie7iloost5m7ohoufrmd45h2ruesfipsbnm",
    ratings: 2,
    ratingsCount: 78,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Fight Clock",
    creator: "vht",
    price: "74",
    categoryName: "Entities",
    topBid: "543",
    minBid: "112",
    rank: "#113",
    img: "https://api.sandbox.game/assets/public/00539f27-0dda-4618-aabc-aae94b50c160/preview?bafkreia3nvvwz4z76gj4kosurod74mg72jznm63gtp3fmql534swyqctyy?bafkreia3nvvwz4z76gj4kosurod74mg72jznm63gtp3fmql534swyqctyy",
    ratings: 4,
    ratingsCount: 245,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Etheria's Planetarium",
    creator: "MissingParts",
    price: "149",
    categoryName: "Entities",
    topBid: "5609",
    minBid: "598",
    rank: "#49",
    img: "https://api.sandbox.game/assets/public/1b1c63f3-8cca-4b46-b0f3-dad4fe562481/preview?bafkreid6pneihyf2bqeuysj6bfqefyjozrort3fifgndiogk4mkwnh2aey?bafkreid6pneihyf2bqeuysj6bfqefyjozrort3fifgndiogk4mkwnh2aey",
    ratings: 5,
    ratingsCount: 564,
    status: "Popular",
  },
  {
    _id: uuid(),
    title: "Light",
    creator: "LadyPixyCompany",
    price: "1155",
    categoryName: "Entities",
    topBid: "6213",
    minBid: "2006",
    rank: "#34",
    img: "https://api.sandbox.game/assets/public/0cfeaf0e-3282-45af-8052-9437aa1111a6/preview?bafkreigjwhpz5qrzsa3wqycl66w7mjx6xshzh24bdzycrcld5o5py3gkyy?bafkreigjwhpz5qrzsa3wqycl66w7mjx6xshzh24bdzycrcld5o5py3gkyy",
    ratings: 5,
    ratingsCount: 67,
    status: "Trending",
  },
  {
    _id: uuid(),
    title: "Advertising Sign",
    creator: "MissingParts",
    price: "2191",
    categoryName: "Entities",
    topBid: "5512",
    minBid: "3216",
    rank: "#114",
    img: "https://api.sandbox.game/assets/public/b59ff34e-bf09-451a-9fc9-e47336afc3ee/preview?bafkreifgv35zmhprryl4fektn6fwxs66mhzisyeryaxnpnh55njhr6b23e?bafkreifgv35zmhprryl4fektn6fwxs66mhzisyeryaxnpnh55njhr6b23e",
    ratings: 2,
    ratingsCount: 43,
    status: "Popular",
  },
];

export const products = [
  ...art,
  ...collectibles,
  ...wearable,
  ...equipment,
  ...entities,
];
